<template lang="html">
  <v-container class='fluid'>

    <c-confirm-dialog v-model="dialogDuplicar" @yes="duplicarAcao()" titulo="Duplicar ação?">
      A duplicação importa somente parte do conteúdo. Ressaltamos a necessidade de revisão, atualização e complementação das informações da nova ação.
    </c-confirm-dialog>

    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Duplicar Ação de Extensão'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>

              <v-layout row wrap justify-space-between>
                <v-flex xs9>
                  <v-text-field
                    label='Número da ação de extensão a ser duplicada'
                    v-model="pesquisa.numero"
                    required
                    :rules="regrasBasicas"
                    max-height="400">
                  </v-text-field>
                </v-flex>

                <v-btn color="primary" text @click="pesquisarProjetoSIEX">Pesquisar</v-btn>
              </v-layout>

              <br><br>

              <div v-show="duplicacao && duplicacao.titulo">
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field
                      label='Título (atualizar o título da ação para que a duplicação seja realizada)'
                      v-model="duplicacao.titulo"
                      required
                      :rules="tituloRules"
                      max-height="400"
                      counter="150">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select
                      label='Tipo de público-alvo'
                      :items="listaTipoPublico"
                      v-model="duplicacao.tipoPublico"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      max-height="400"
                      return-object
                      required
                      autocomplete
                      :rules="regrasBasicas" >
                    </v-select>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field
                      label='Público-alvo estimado'
                      v-model="duplicacao.publicoAlvo"
                      mask='#########'
                      required
                      :rules="regrasBasicas"
                      max-height="20">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs11 sm5>
                    <c-date-menu label="Data de início" v-model="duplicacao.dataInicio" required :rules="regrasBasicas"></c-date-menu>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs11 sm5>
                    <c-date-menu label="Data de conclusão" v-model="duplicacao.dataConclusao" required :rules="regrasBasicas"></c-date-menu>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>
              </div>
            </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="botaoDuplicarAcao" :disabled="!formularioValido">Duplicar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import ConfirmDialog from '@/components/c-confirm-dialog'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      dialogDuplicar: false,
      formularioValido: false,
      dates: dates,
      listaTipoPublico: [],
      tituloAnterior: '',
      duplicacao: {
        titulo: '',
        tipoPublico: {},
        publicoAlvo: undefined,
        dataInicio: undefined,
        dataConclusao: undefined
      },
      pesquisa: {
        numero: undefined
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      tituloRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 150 || 'Este campo não pode possuir mais que 150 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      truncate (string, limit) {
        if (string.length > limit) return string.substring(0, limit) + '...'
        else return string
      },
      pesquisarProjetoSIEX: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação.' })
        projetos.getDuplicacao(this.pesquisa.numero)
        .then(response => {
          this.duplicacao = response.data
          this.tituloAnterior = this.duplicacao.titulo
          this.duplicacao.tipoPublico = undefined
          this.duplicacao.publicoAlvo = undefined
          this.duplicacao.dataInicio = undefined
          this.duplicacao.dataConclusao = undefined
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação.' })
        })
      },
      botaoDuplicarAcao: function () {
        if (this.duplicacao.titulo === this.tituloAnterior) {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: 'O título da ação duplicada deve ser diferente do título da ação original!'})
          return
        }
        this.dialogDuplicar = true
      },
      duplicarAcao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Duplicando ação.' })
        projetos.postDuplicacao(this.pesquisa.numero, this.duplicacao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          let link = response.body.link
          let idProjetoAux = link.split('/')[5]
          this.$router.push({name: 'ProjetoFormulario', params: {idProjeto: idProjetoAux}})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Duplicando ação.' })
        })
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
        })
      }
    },
    mounted () {
      this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico')
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-confirm-dialog': ConfirmDialog
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// duplicar-projeto.vue?8f65a99c